import * as z from "zod";

import errorMessages from "../error-messages";

const MemberFormSchema = z.object({
  assigneeFirstName: z
    .string({
      required_error: errorMessages.required,
    })
    .min(1, {
      message: errorMessages.required,
    }),
  assigneeLastName: z
    .string({
      required_error: errorMessages.required,
    })
    .min(1, {
      message: errorMessages.required,
    }),
  assigneePhone: z
    .string({
      required_error: errorMessages.invalidPhoneNumber,
    })
    .min(6, {
      message: errorMessages.required,
    }),
  assigneeEmail: z
    .string({
      required_error: errorMessages.required,
    })
    .min(1, {
      message: errorMessages.required,
    })
    .refine((value) => /\S[^\s@]*@\S+\.\S+/.test(value), {
      message: errorMessages.invalidEmail,
    }),
  assigneeFunction: z.string().nullish().optional(),
  assigneeService: z.string().nullish().optional(),
  assigneeRank: z.number(), // Assuming this is expected to always be a number
});

type MemberFormSchemaType = z.infer<typeof MemberFormSchema>;

// Default values for a form reset or initial state
const MemberFormSchemaDefaultValues = {
  assigneeFirstName: "",
  assigneeLastName: "",
  assigneePhone: "",
  assigneeEmail: "",
  assigneeFunction: "",
  assigneeService: "",
  assigneeRank: 6,
};

export type { MemberFormSchemaType };
export { MemberFormSchema, MemberFormSchemaDefaultValues };
